import { StyleSheet, View } from 'react-native'
import { Icon, Text, useTheme } from 'react-native-paper'
import { useSemanticColors } from '@/constants/SemanticColors'

interface TrendIndicatorProps {
    changePercent: number
}

export function TrendIndicator({ changePercent }: TrendIndicatorProps) {
    const theme = useTheme()
    const semanticColors = useSemanticColors()

    if (changePercent === 0) {
        return (
            <View style={styles.container}>
                <Icon source="minus" size={14} color={theme.colors.onSurfaceVariant} />
                <Text variant="labelSmall" style={{ color: theme.colors.onSurfaceVariant }}>
                    0%
                </Text>
            </View>
        )
    }

    const isPositive = changePercent > 0
    const color = isPositive ? semanticColors.successText : theme.colors.error
    const icon = isPositive ? 'arrow-up' : 'arrow-down'
    const formatted = `${Math.abs(changePercent).toFixed(1)}%`

    return (
        <View style={styles.container}>
            <Icon source={icon} size={14} color={color} />
            <Text variant="labelSmall" style={{ color }}>
                {formatted}
            </Text>
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 2,
    },
})
